import defaultMessagesQueries from "$/lib/queries/default-messages-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/default-messages")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(defaultMessagesQueries.detail())
    return { crumb: "Standardmeddelanden" }
  },
})
